import PendoIcon from '../icon/pendo-icon.vue.js';
import { keyCodes } from '../../utils/utils.js';

const TYPE_ICON_MAP = {
  success: {
    type: 'check-circle-2-solid',
    fill: '#00c583',
    stroke: '#fff',
    size: 32
  },
  info: {
    type: 'info-solid',
    fill: '#128297',
    stroke: '#fff',
    size: 32
  },
  warning: {
    type: 'alert-circle-solid',
    fill: '#dba211',
    stroke: '#fff',
    size: 32
  },
  error: {
    type: 'minus-circle-solid',
    fill: '#db1111',
    stroke: '#fff',
    size: 32
  }
};
var script = {
  components: {
    PendoIcon
  },
  data() {
    return {
      verticalOffset: 0,
      closed: false,
      visible: false,
      timer: null
    };
  },
  computed: {
    icon() {
      return TYPE_ICON_MAP[this.type];
    },
    positionStyle() {
      const position = this.position.includes('top') ? 'top' : 'bottom';
      return {
        [position]: `${this.verticalOffset}px`
      };
    }
  },
  watch: {
    closed(newVal) {
      if (newVal) {
        this.visible = false;
        this.$el.addEventListener('transitionend', this.destroyElement);
      }
    }
  },
  mounted() {
    this.startTimer();
    document.addEventListener('keydown', this.keydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.keydown);
  },
  methods: {
    destroyElement() {
      this.$el.removeEventListener('transitionend', this.destroyElement);
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },
    close() {
      this.closed = true;
      if (typeof this.onClose === 'function') {
        this.onClose();
      }
    },
    clearTimer() {
      clearTimeout(this.timer);
    },
    startTimer() {
      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          if (!this.closed) {
            this.close();
          }
        }, this.duration);
      }
    },
    keydown(event) {
      switch (event.keyCode) {
        case keyCodes.backspace:
        case keyCodes.delete:
          this.clearTimer();
          break;
        case keyCodes.esc:
          if (!this.closed) {
            this.close();
          }
          break;
        default:
          this.startTimer();
          break;
      }
    }
  }
};

export { script as default };
//# sourceMappingURL=notification.vue2.js.map
